import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { getIntervals } from './intervals';
import { LinkField } from '../../LinkField';
export function RepeatReminderDropdown() {
    const { intervals } = getIntervals();
    const [isOpen, setOpen] = useState(false);
    const [reminderDueDateField] = useField('reminder.dueDate');
    const [reminderIntervalField, , helpers] = useField('reminder.interval');
    const dueDate = reminderDueDateField.value;
    const interval = reminderIntervalField.value || undefined;
    const { label = '' } = intervals.find(({ value }) => value === interval) || {};
    const handleChange = (value) => {
        helpers.setValue(value);
    };
    if (!dueDate) {
        return null;
    }
    return (<Menu.Root open={isOpen} onClose={() => setOpen(false)} target={<LinkField name="reminder.interval" icon={<Falcon icon="repeat"/>} onClick={() => setOpen(!isOpen)} onRemove={() => handleChange(undefined)} linkPrefix={t({
                message: 'Repeat reminder',
                comment: 'Task repeat reminder field when set',
            })} linkText={interval ? label : t({ message: 'Add repeater', comment: 'Task repeat reminder field no repeat set' })}/>}>
      {intervals.map((item) => (<Menu.ItemRadio key={item.value} checked={item.value === interval} onChange={() => handleChange(item.value)}>
          {item.label}
        </Menu.ItemRadio>))}
    </Menu.Root>);
}
